import { render, staticRenderFns } from "./DiscussEdit.vue?vue&type=template&id=079ffd62"
import script from "./DiscussEdit.vue?vue&type=script&lang=js"
export * from "./DiscussEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports